// Layout del panel profesor: sidebar fijo + outlet.
// Reusa estilos del admin (decisión 4 SS7.2: mismo diseño).

import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Calendar, CalendarPlus, LogOut } from 'lucide-react';

import Logo from '../Logo';
import { useAuth } from '../../context/AuthContext';

export default function ProfesorLayout() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  const links = [
    { to: '/profesor', icon: Calendar, label: t('profesor.nav.mis_clases'), end: true },
    { to: '/profesor/reservar-como-alumno', icon: CalendarPlus, label: t('profesor.nav.reservar_como_alumno') },
  ];

  return (
    <div className="admin-app">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <Logo />
          <span className="admin-brand-tag">{t('profesor.brand_tag')}</span>
        </div>
        <nav className="admin-nav">
          {links.map(({ to, icon: Icon, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => 'admin-nav-link' + (isActive ? ' active' : '')}
            >
              <Icon size={18} strokeWidth={1.5} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="admin-user">
          <div className="admin-user-info">
            <span className="admin-user-name">{user?.nombre || user?.email}</span>
            <span className="admin-user-rol">{user?.rol}</span>
          </div>
          <button type="button" className="admin-user-logout" onClick={handleLogout} aria-label={t('auth.menu.cerrar_sesion')}>
            <LogOut size={16} strokeWidth={1.5} />
          </button>
        </div>
      </aside>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
